import { useQuery } from "../../api/useQuery.js";
import { getAllAITests } from "../../api/queries.js";
import { TestList } from "../../components/organisms/TestList.js";
import { LoadingRows, QueryStatus } from "../../components/ui/LoadingPlaceholders.js";
import { PageTitle } from "../../components/ui/PageTitle.js";
import { EmptyState, ErrorState, useT } from "@mmm/ui";
export function GlobalTestsScreen() {
  const t = useT();
  const query = useQuery(getAllAITests, undefined);
  return <div className="mmm-global-tests-screen">
    <PageTitle title={t("nav.tests")} />
    <QueryStatus queries={[query]} />
    {query.error && !query.waiting ? <ErrorState title={t("tests.loadTestFailed")} onRetry={query.retry} />
      : query.loading ? <LoadingRows rows={5} />
      : query.data?.length ? <TestList tests={query.data} />
      : <EmptyState title={t("tests.noTestsTitle")} message={t("tests.noTestsMessage")} />}
  </div>;
}
